/* global client, checkoutId */

import Cookies from 'js-cookie'
import AOS from 'aos';
import reframe from 'reframe.js';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, EffectFade } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, EffectFade]);
// import { Fancybox } from '@fancyapps/ui';

/*/////////////////////////////////////////////
  Initiate store
*//////////////////////////////////////////////

var store = function() {
  /*/////////////////////////////////////////////
    Setup shopify client
  *//////////////////////////////////////////////
  window.client = window.ShopifyBuy.buildClient({
    domain: 'the-anti-architect.myshopify.com',
    storefrontAccessToken: '86c8a9793062420f65f2d25152f7971c',
  });

  window.checkoutId = Cookies.get('checkout');

  client.collection.fetchAllWithProducts().then((collections) => {
    window.populateCollections(collections);
    console.log(collections);
  });

  if(checkoutId) {
    client.checkout.fetch(checkoutId).then((checkout) => {
      populateCart(checkout);
    }).catch((error) => {
      client.checkout.create().then((checkout) => {
        Cookies.set('checkout', checkout['id'])
        window.checkoutId = checkout['id'];
      });
    });
  } else {
    client.checkout.create().then((checkout) => {
      Cookies.set('checkout', checkout['id'])
      window.checkoutId = checkout['id'];
    });
  }
}

/*/////////////////////////////////////////////
  Populate Cart
*//////////////////////////////////////////////

var populateCart = function(checkout) {
  console.log(checkout);

  let cart = []
  let cartCount = 0;
  let cartTotalPrice = checkout.totalPrice;
  let checkoutUrl = checkout.webUrl;

  checkout.lineItems.forEach(function (value, i){
    cartCount += value.quantity;

    let newLineItem = {};

    newLineItem['title'] = value.title;
    newLineItem['variantTitle'] = value.variant.title;
    newLineItem['handle'] = value.variant.product.handle;
    newLineItem['lineItemId'] = value.id;
    newLineItem['variantId'] = value.variant.id;
    newLineItem['quantity'] = value.quantity;
    newLineItem['price'] = value.variant.price;
    newLineItem['color'] = 'Cobalt Blue';
    newLineItem['image'] = value.variant.image.src;

    cart.push(newLineItem);
  })

  window.dispatchEvent(new CustomEvent('loadcheckout', 
    {
      detail: {
        cart: cart,
        cartCount: cartCount,
        cartTotalPrice: cartTotalPrice,
        checkoutUrl: checkoutUrl,
      },
    }
  ));
  
  // Do something with the product
}

/*/////////////////////////////////////////////
  Add to cart button
*//////////////////////////////////////////////

window.addToCart = function(variantId) {
  console.log(variantId);
  const lineItemsToAdd = [
    {
      variantId: variantId,
      quantity: 1,
    },
  ];

  client.checkout.addLineItems(checkoutId, lineItemsToAdd).then((checkout) => {
    console.log(checkout);
    populateCart(checkout);
  });
  
}

/*/////////////////////////////////////////////
  Remove from cart button
*//////////////////////////////////////////////

window.removeFromCart = function(lineItemId) {

  // console.log('remove');
  client.checkout.removeLineItems(checkoutId, lineItemId).then((checkout) => {
    // console.log(checkout);
    populateCart(checkout);
  });
}

/*/////////////////////////////////////////////
  Update Quantity
*//////////////////////////////////////////////

window.updateQuantity = function(lineItemId, quantity) {

  console.log('update');
  client.checkout.updateLineItems(checkoutId, [{id: lineItemId, quantity: quantity}]).then((checkout) => {
    // console.log(checkout);
    populateCart(checkout);
  });
}

/*/////////////////////////////////////////////
  Populate Collections
*//////////////////////////////////////////////

window.populateCollections = function(rawCollections) {
  let collections = [];

  rawCollections.forEach(function (value, i){
    // cartCount += value.quantity;

    let newCollection = {};
    let products = [];
    // console.log(value);

    newCollection['title'] = value.title;
    newCollection['handle'] = value.handle;

    value.products.forEach(function (value, i){
      let newProduct = {};
      newProduct['title'] = value.title;
      newProduct['id'] = value.id;
      newProduct['handle'] = value.handle;
      newProduct['image'] = value.images[0].src;
      newProduct['price'] = value.variants[0].price;

      products.push(newProduct);
    })
    newCollection['products'] = products;

    collections.push(newCollection);
  })

  window.dispatchEvent(new CustomEvent('fetchcollections', 
    {
      detail: {
        collections: collections,
      },
    }
  ));
}


export default {
  init() {
    AOS.init();
    store();
    reframe('iframe'); // Wrap all iFrames in the page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
